import { z } from "zod";
import { CarryInBaseSchema } from "../generated/CarryIn";
import { CarryOutBaseSchema } from "../generated/CarryOut";
import { ConstructionBaseSchema } from "../generated/Construction";
import { ConstructionPlanBaseSchema } from "../generated/ConstructionPlan";
import { ConstructionPlanAreaBaseSchema } from "../generated/ConstructionPlanArea";
import { ConstructionRecordBaseSchema } from "../generated/ConstructionRecord";
import { GroupBaseSchema } from "../generated/Group";
import { IssuanceBaseSchema } from "../generated/Issuance";
import { LotBaseSchema } from "../generated/Lot";
import { MaterialBaseSchema } from "../generated/Material";
import { UserBaseSchema } from "../generated/User";
import { WorkBaseSchema } from "../generated/Work";

// targetIds は工事(Work, id=number)。userId は担当者で収集する各エンティティの絞り込みに使う。
export const GetWorkCachePayloadSchema = z.object({
  targetIds: z.number().array(),
  userId: z.string().uuid(),
});
export type getWorkCachePayload = z.infer<typeof GetWorkCachePayloadSchema>;

// 一括キャッシュ応答。全バケットが平坦(id 重複なし)で、施工箇所も従来の
// ConstructionPlans[].ConstructionPlanAreas ネストから独立バケット ConstructionPlanAreas へ分離済み。
// キー名は web IndexedDB の SetCache 収集キー(PascalCase 複数形)と一致させる。
// 工事は Works(Work 基準)で返す(旧 ConstructionWorks は廃止)。
export const WorkCacheDataSchema = z.object({
  CarryIns: CarryInBaseSchema.rows,
  CarryOuts: CarryOutBaseSchema.rows,
  ConstructionPlanAreas: ConstructionPlanAreaBaseSchema.rows,
  ConstructionPlans: ConstructionPlanBaseSchema.rows,
  ConstructionRecords: ConstructionRecordBaseSchema.rows,
  Constructions: ConstructionBaseSchema.rows,
  Groups: GroupBaseSchema.rows,
  Issuances: IssuanceBaseSchema.rows,
  Lots: LotBaseSchema.rows,
  Materials: MaterialBaseSchema.rows,
  Users: UserBaseSchema.rows,
  Works: WorkBaseSchema.rows,
});
export type workCacheData = z.infer<typeof WorkCacheDataSchema>;

// キャッシュ対象一覧の軽量プレビュー行(一覧に必要な列だけを返す設計意図を維持)。
// 工事(Work)は担当者を持たないため、従来の preparer_user_id / User ネストは無い。
// 一覧の識別名(short_name / official_name)と登録日だけを返す。
export const WorkPreviewRowSchema = z.object({
  createdAt: z.number(),
  id: z.number(),
  official_name: z.string(),
  short_name: z.string(),
});
export const WorkPreviewRowsSchema = WorkPreviewRowSchema.array();
export type WorkPreviewRow = z.infer<typeof WorkPreviewRowSchema>;

// キャッシュ対象一覧の正規化応答。工事は担当者を持たないため related の id 結合対象は無く、related は空にする。
export const normalizedCacheableWorksResponseSchema = z.object({
  Works: WorkPreviewRowsSchema,
  related: z.object({}),
});
export type NormalizedCacheableWorksResponse = z.infer<typeof normalizedCacheableWorksResponseSchema>;
